import React from "react";
const useGetWixClientPromise = (instance, existingWixClientGetter) => {
  const getWixClientPromise = React.useMemo(() => {
    let wixClientPromise;
    return () => {
      if (wixClientPromise) {
        return wixClientPromise;
      }
      wixClientPromise = import(
        /* webpackChunkName: "wix-ricos-sdk-client" */
        "@wix/sdk/client"
      ).then((clientSdk) => {
        return clientSdk.createClient({
          auth: {
            getAuthHeaders: () => ({ headers: { Authorization: instance } })
          }
        });
      });
      return wixClientPromise;
    };
  }, [instance]);
  return existingWixClientGetter ? { getWixClientPromise: existingWixClientGetter } : { getWixClientPromise };
};
export {
  useGetWixClientPromise
};
//# sourceMappingURL=use-get-wix-client-promise.js.map
